import React from "react";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

const Style = styled.div`
h5{
    
    font-size:18px !important;
}
`;

export  const TopNav =({ TextComp,DropDownText,DropDownArray,RightComp,TopNavClassName })=> {
    //the component could be better befor using next time use span
    return (
        <Style>
            <div className={`d-flex flex-wrap justify-content-between align-items-center ${TopNavClassName}`}>
                <div className="  mb-3 mb-lg-0">{TextComp}</div>
                <div>
                    {RightComp && <span className="">{RightComp}</span>}
                    {DropDownText && <Dropdown>
                        <Dropdown.Toggle className="dropdown-6 bg-white text-black border text-muted">
                            {DropDownText}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1">Last Month</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">Last Week</Dropdown.Item>
                            <Dropdown.Item href="#/action-3">Yesterday</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>}  
                </div>
            </div>
        </Style>
    );
};


export  const TopNav2 =({ TextComp,RightComp,TopNav2ClassName })=> {
    //the component could be better befor using next time use span
    return (
        <Style>
            <div className={`row align-items-center mb-2 ${TopNav2ClassName}` }>
                <span className="text-muted font-weight-normal col-6">{TextComp}</span>
                <div className="col-6">
                    {RightComp && <span className="">{RightComp}</span>}
                     
                </div>
            </div>
        </Style>
    );
};